export const testimonials = [
  {
    id: 1,
    name: 'Marco R.',
    handle: '@marcorossi',
    avatar: 'MR',
    avatarBg: 'bg-primary-100 text-primary-700',
    text: 'Itaobuy Spreadsheet ha completamente cambiato il mio modo di fare shopping online. Finalmente un modo organizzato per trovare tutto ciò che cerco senza perdere ore a navigare.',
  },
  {
    id: 2,
    name: 'Elena B.',
    handle: '@elenabianchi',
    avatar: 'EB',
    avatarBg: 'bg-accent-100 text-accent-800',
    text: 'Uso Itaobuy Spreadsheet da mesi e non potrei più farne a meno. La categoria scarpe è la mia preferita: trovo sempre modelli nuovi e interessanti.',
  },
  {
    id: 3,
    name: 'Alessandro F.',
    handle: '@alessandroferrari',
    avatar: 'AF',
    avatarBg: 'bg-secondary-100 text-secondary-700',
    text: 'Guida completa e dettagliata. Ho imparato a usare Itaobuy Spreadsheet in pochi minuti grazie ai tutorial. Consigliatissimo per chi inizia.',
  },
  {
    id: 4,
    name: 'Giulia M.',
    handle: '@giuliamarino',
    avatar: 'GM',
    avatarBg: 'bg-accent-100 text-accent-800',
    text: 'Le informazioni sulla sicurezza mi hanno rassicurata molto. Sapevo di poter navigare tranquilla grazie ai consigli pratici che ho trovato sul sito.',
  },
  {
    id: 5,
    name: 'Lorenzo P.',
    handle: '@lorenzoponti',
    avatar: 'LP',
    avatarBg: 'bg-primary-100 text-primary-700',
    text: 'Miglior strumento per organizzare le ricerche di prodotti! La struttura a categorie è intuitiva e mi fa risparmiare tantissimo tempo ogni settimana.',
  },
  {
    id: 6,
    name: 'Francesca D.',
    handle: '@francescadonati',
    avatar: 'FD',
    avatarBg: 'bg-secondary-100 text-secondary-700',
    text: 'Ho scoperto categorie che non sapevo nemmeno esistessero. Itaobuy Spreadsheet è una miniera d\'oro per chi ama lo shopping intelligente.',
  },
];